
<template>

</template>

<script>
    
  import { mapGetters, mapActions } from "vuex";

  export default {
    
    name: 'Hidden',

    props: [],

    computed : {

    },

    methods:{
    
    }
  
  }

    
</script>

<style scoped>

</style>
